import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startCase } from 'lodash';
import './Disclosure.scss';

import { getUserAddress } from 'src/redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  getCharitiesArray,
  getSelectedQCDFunds,
  getCharitiesTotalGrossAmount,
  getSingleAddressSelectedFunds,
  getIsMailACheck,
  getCheckbox,
  getIsReduceAutoRMD,
  getRothAndRolloverOnly,
  getRMDReductionAmount,
  getEligibleQcdTradeDates,
} from '../../../redux/modules/qcd/qcd.selectors';
import { getIsRMDEligible } from '../../../redux/modules/RMD/RMDSetting.selectors';
import { replaceSpecialCharacterWith } from '../../../utils/shoppingCart/shopping-cart-utility';
import {
  REDUCE_AUTO_RMD_DISTRIBUTION_MODAL,
  openModal,
} from '../../../redux/modules/modals/modals.module';
import { SSJBeaconCheckbox } from '../../Shared/Beacon/Registry';
import {
  DisclosureAgree,
  ReduceAutoRMD,
} from '../../../redux/modules/qcd/qcd.module';
import ToolTip from '../../Shared/ToolTip/ToolTip';
import { formatUnixDate } from '../../../utils/dates/date-utility';
import { currency } from '../../../utils/utils';
import tooltip_qcd from 'src/assets/images/tooltip_qcd.png';
import { TRADE_DATE_TOOLTIP } from '../../../utils/transactions-util';

function modifiedText(text) {
  const splitText = text.split('_');
  return startCase(splitText[0].toLowerCase()) + ' ' + splitText[1];
}

const Disclosure = () => {
  const dispatch = useDispatch();
  const isChecked = useSelector(getCheckbox);
  const reduceAutoRMD = useSelector(getIsReduceAutoRMD);
  const charities = useSelector(getCharitiesArray);
  const funds = useSelector(getSelectedQCDFunds);
  const userAddress = useSelector(getUserAddress);
  const totalRMDReductionAmountAmount = useSelector(getRMDReductionAmount);
  const totalGrossAmount = useSelector(getCharitiesTotalGrossAmount);
  const charitiesNum = Object.keys(charities).length;
  const hasSingleAddress = useSelector(getSingleAddressSelectedFunds);
  const isMailACheck = useSelector(getIsMailACheck);
  const isOnlyRothAndRollover = useSelector(getRothAndRolloverOnly);
  const isRMDEligible = useSelector(getIsRMDEligible);
  const qcdTradeDates = useSelector(getEligibleQcdTradeDates);

  return (
    <div className="disclosure-container">
      <div className="distribution-content">
        <div className="distribute-to-header">Distribution to</div>
        {hasSingleAddress && (
          <div className="distribute-to-table blocked_data">
            {charitiesNum > 0 && (
              <table>
                <tr className="distribute-table-header">
                  <th className="distribute-charityName ">Charity</th>
                  <th className="distribute-address">Address</th>
                  <th className="distribute-amount">Amount</th>
                </tr>
                {charities.map((charity) => (
                  <tr className="distribute-table-row">
                    <td className="distribute-charityName">
                      <p className="charity-fund-name-sub-header">
                        Check Payable To
                      </p>
                      <p className="charity-fund-name blocked_data">
                        {charity.charityName}
                      </p>
                    </td>
                    {!isMailACheck && (
                      <td className="distribute-address-data blocked_data">
                        {charity.attention && (
                          <p className="attention-text">
                            Attn: {charity.attention}
                          </p>
                        )}
                        <p>{charity.addressLineOne}</p>
                        {charity.addressLineTwo && (
                          <p>{charity.addressLineTwo}</p>
                        )}
                        <p>
                          {charity.city}, {charity.state} {charity.zip}
                          {charity.zipExt && -charity.zipExt}
                        </p>
                      </td>
                    )}
                    {isMailACheck && (
                      <td className="distribute-address-data blocked_data">
                        {charity.attention && (
                          <p className="attention-text">
                            Attn: {charity.attention}
                          </p>
                        )}
                        <p>{startCase(userAddress.street1.toLowerCase())}</p>
                        {userAddress.street2 && (
                          <p>{startCase(userAddress.street2.toLowerCase())}</p>
                        )}
                        <p>
                          {userAddress.city}, {userAddress.state}
                          {userAddress.zip}
                          {userAddress.zipCodeExt && -userAddress.zipCodeExt}
                        </p>
                      </td>
                    )}
                    <td className="distribute-amount distribute-amount-data blocked_data">
                      {currency(charity?.grossAmountDollars)}
                    </td>
                  </tr>
                ))}
              </table>
            )}
          </div>
        )}
        {!hasSingleAddress && isMailACheck && (
          <div className="distribute-to-table blocked_data">
            {charitiesNum > 0 && (
              <table>
                <tr className="distribute-table-header">
                  <th className="distribute-charityName">Delivery Method</th>
                  <th className="distribute-address">Account</th>
                  <th className="distribute-amount">Amount</th>
                </tr>
                {funds.map((fund) => (
                  <tr className="distribute-table-row blocked_data">
                    <td className="distribute-address-data blocked_data">
                      <p className="charity-fund-name-sub-header">
                        Mail Check To
                      </p>
                      <p>{startCase(fund.address.street1?.toLowerCase())}</p>
                      {fund.address.street2 && (
                        <p>{startCase(fund.address.street2?.toLowerCase())}</p>
                      )}
                      <p>
                        {fund.address.city}, {fund.address.state}{' '}
                        {fund.address.zip}
                        {fund.address.zipCodeExt && -fund.address.zipCodeExt}
                      </p>
                    </td>
                    <td className="distribute-address blocked_data">
                      <p className="charity-fund-name-sub-header">
                        {startCase(
                          replaceSpecialCharacterWith(
                            fund.displayClassification,
                            '-'
                          ).toLowerCase()
                        )}{' '}
                        / {modifiedText(fund.agreementType)}
                      </p>
                      <div>
                        <span className="charity-fund-name">
                          {fund.fundName}
                        </span>
                        <span className="fund-ticker">{fund.ticker}</span>
                      </div>
                      <p className="distribute-address-data">
                        {fund.agreementNumber} • {fund.formattedEntityNames}
                      </p>
                      <p>
                        <span className="projected-trade-date-text">
                          Projected Trade Date:{' '}
                        </span>
                        <span className="projected-trade-date">
                          {formatUnixDate(qcdTradeDates[fund.agreementID])}
                        </span>
                        <span>
                          <ToolTip message={TRADE_DATE_TOOLTIP} />
                        </span>
                      </p>
                    </td>
                    <td className="distribute-amount distribute-amount-data blocked_data">
                      {currency(fund?.grossAmountDollars)}
                    </td>
                  </tr>
                ))}
              </table>
            )}
          </div>
        )}
        <div className="distribute-from-header blocked_data">
          {hasSingleAddress ? 'Distribution from' : 'Distribution for'}
        </div>
        {hasSingleAddress && (
          <div className="distribute-from-table blocked_data">
            {charitiesNum > 0 && (
              <table>
                <tr className="distribute-table-header">
                  <th className="fund-name">Account</th>
                  <th className="fund-amount">Amount</th>
                </tr>
                {funds.map((fund) => (
                  <tr className="distribute-table-row blocked_data">
                    <td className="fund-name blocked_data">
                      <p className="charity-fund-name-sub-header">
                        {startCase(
                          replaceSpecialCharacterWith(
                            fund.displayClassification,
                            '-'
                          ).toLowerCase()
                        )}{' '}
                        / {modifiedText(fund.agreementType)}
                      </p>
                      <div>
                        <span className="charity-fund-name">
                          {fund.fundName}
                        </span>
                        <span className="fund-ticker">{fund.ticker}</span>
                      </div>
                      <p className="distribute-address-data">
                        {fund.agreementNumber} • {fund.formattedEntityNames}
                      </p>
                      <p>
                        <span className="projected-trade-date-text">
                          Projected Trade Date:{' '}
                        </span>
                        <span className="projected-trade-date">
                          {formatUnixDate(qcdTradeDates[fund.agreementID])}
                        </span>
                        <span>
                          <ToolTip message={TRADE_DATE_TOOLTIP} />
                        </span>
                      </p>
                    </td>
                    <td className="distribute-amount distribute-amount-data blocked_data">
                      {currency(fund?.grossAmountDollars)}
                    </td>
                  </tr>
                ))}
              </table>
            )}
          </div>
        )}
        {!hasSingleAddress && isMailACheck && (
          <div className="distribute-from-table">
            {charitiesNum > 0 && (
              <table>
                <thead>
                  <tr className="distribute-table-header">
                    <th className="distribute-charityName">Charity</th>
                    <th className="distribute-address">Attention</th>
                    <th className="distribute-amount">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {charities.map((charity) => (
                    <tr className="distribute-table-row blocked_data">
                      <td className="distribute-charityName blocked_data">
                        <p className="charity-fund-name-sub-header">
                          Check Payable To
                        </p>
                        <p className="charity-fund-name">
                          {charity.charityName}
                        </p>
                      </td>
                      <td className="distribute-address-data blocked_data">
                        {charity.attention && (
                          <p className="attention-text">
                            Attn: {charity.attention}
                          </p>
                        )}
                      </td>
                      <td className="distribute-amount distribute-amount-data blocked_data">
                        {currency(charity?.grossAmountDollars)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
      <div className="projected-trade-date-container">
        <span className="projected-trade-date-text" />
        <span className="projected-trade-date" />
        <span />
        <div className="total-distribution-container">
          <span className="total-distribution-text">
            Total Distribution Amount
          </span>
          <span className="total-distribution-amount blocked_data">
            {currency(totalGrossAmount)}
          </span>
        </div>
        {!isOnlyRothAndRollover && isRMDEligible && (
          <div className="reduce-auto-rmd-container">
            <div className="disclosure-checkbox-container">
              <SSJBeaconCheckbox
                id="reduce-auto-rmd-checkbox"
                name="reduce-auto-rmd-checkbox"
                label={
                  'Reduce my existing RMD program by ' +
                  currency(totalRMDReductionAmountAmount) +
                  '* (optional)'
                }
                checked={reduceAutoRMD}
                required={false}
                onClick={() => {
                  dispatch(ReduceAutoRMD(!reduceAutoRMD));
                }}
                errorsmap='{"required":"Custom Required Field Messsage"}'
              />
            </div>
            <button
              className="rmd-deduction-amount-disclosure-link"
              onClick={() =>
                dispatch(openModal(REDUCE_AUTO_RMD_DISTRIBUTION_MODAL))
              }
            >
              <img
                className="reduce-auto-rmd-image"
                alt="tool tip icon"
                src={tooltip_qcd}
              />
            </button>
            <p className="reduce-auto-rmd-sub-text">
              *Amount shown includes QCDs from Traditional and Rollover IRAs
              only.
            </p>
          </div>
        )}
      </div>
      <div className="disclosure-header">
        I direct T. Rowe Price to make a QCD in the manner I have indicated. I
        certify the following:
      </div>
      <div className="disclosure-content">
        <ul className="disclosure-list">
          <li>
            I am responsible for determining if my distribution request
            satisfies the requirements under IRC Section 408(d)(8).
          </li>
          <li>
            I agree to indemnify and hold harmless T. Rowe Price and its
            affiliates from and against any and all claims or causes of action,
            or any losses and liabilities, incurred as a result of my
            instructions in this request and in the event I fail to meet any of
            the IRS requirements for a QCD.
          </li>
          <li>Income tax withholding will not be applied to this request.</li>
          <li>I am a U.S. person (including a resident alien).</li>
        </ul>
      </div>
      <SSJBeaconCheckbox
        id="disclosure-checkbox"
        name="disclosure-checkbox"
        label="I understand and agree."
        checked={isChecked}
        required={true}
        onClick={() => {
          dispatch(DisclosureAgree(!isChecked));
        }}
        errorsmap='{"required":"Custom Required Field Messsage"}'
      />
      <div className="disclosure-please-note">
        <b className="bolded-text">Please Note:</b> Since you must receive
        acknowledgment of your contribution, you should follow up with the
        charity directly for a receipt of your donation.
      </div>
    </div>
  );
};

export default Disclosure;
